import React from 'react';
import styled, { css } from 'styled-components';

const ButtonStyles = styled.button`
  display: inline-block;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: linear-gradient(90deg, #2d6cff 0%, #3a8fff 100%);
  color: #fff;
  box-shadow: 0 0 16px 0 #2d6cff88, 0 2px 8px 0 #0002;

  &:hover {
    background: linear-gradient(90deg, #3a8fff 0%, #2d6cff 100%);
    box-shadow: 0 0 32px 0 #2d6cffcc, 0 4px 16px 0 #0003;
    transform: translateY(-2px) scale(1.04);
  }

  &:active {
    transform: translateY(0) scale(0.98);
    box-shadow: 0 0 8px 0 #2d6cff88, 0 1px 4px 0 #0002;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    padding: 0.85rem 1.5rem;
    font-size: 1.1rem;
  }

  @media (max-width: 480px) {
    padding: 0.8rem 2rem;
    font-size: 1rem;
    width: 100%;
    max-width: 250px;
  }
`;

function Button({ children, ...props }) {
  return <ButtonStyles {...props}>{children}</ButtonStyles>;
}

export default Button; 